import React, { Fragment, useState, useEffect } from 'react';
import { getImportDutyReportService, getExportIncentiveReportService } from '../../../services/DutySavingReportService';
import { getBRCorelationService } from '../../../services/MasterService';
import { Table, Button, DatePicker, message, Input, Select, Tabs } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import { getAllAdminIECsService } from '../../../services/FileDataService';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import ReportDateFilter from '../../../components/ReportDateFilter';
import { getTodaysDate, formatToTwoDecimals } from '../../../utilities/utils';

import useColumnVisibility from '../../../hooks/useColumnVisibility';
import ColumnSelector from '../../../components/common/ColumnSelector';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

// ─── Import Tab Columns ────────────────────────────────────────────────────────
const importColumns = [
  { title: 'Business Unit', dataIndex: 'business_unit', key: 'business_unit', header: 'Business Unit', width: 160, fixed: 'left' },
  { title: 'Plant Name', dataIndex: 'plant_name', key: 'plant_name', header: 'Plant Name', width: 150, fixed: 'left' },
  { title: 'Month', dataIndex: 'month', key: 'month', header: 'Month', width: 90 },
  { title: 'Importer Name & Add.', dataIndex: 'importer_name_address', key: 'importer_name_address', header: 'Importer Name & Add.', width: 220 },
  { title: 'SEZ/DTA', dataIndex: 'sez_dta', key: 'sez_dta', header: 'SEZ/DTA', width: 110 },
  { title: 'Org. Code', dataIndex: 'org_code', key: 'org_code', header: 'Org. Code', width: 130 },
  { title: 'Port Code', dataIndex: 'port_code', key: 'port_code', header: 'Port Code', width: 130 },
  { title: 'BE No.', dataIndex: 'be_number', key: 'be_number', header: 'BE No.', width: 110 },
  { title: 'BE Dt.', dataIndex: 'be_date', key: 'be_date', header: 'BE Dt.', width: 100 },
  { title: 'IEC/BR', dataIndex: 'iec_br', key: 'iec_br', header: 'IEC/BR', width: 110 },
  { title: 'Mode', dataIndex: 'transport_mode', key: 'transport_mode', header: 'Mode', width: 90 },
  { title: 'Origin Country', dataIndex: 'origin_country', key: 'origin_country', header: 'Origin Country', width: 170 },
  { title: 'Consignment Country', dataIndex: 'consignment_country', key: 'consignment_country', header: 'Consignment Country', width: 210 },
  { title: 'CHA Name', dataIndex: 'cha_name', key: 'cha_name', header: 'CHA Name', width: 120 },
  { title: 'BE BCD Amt. (INR)', dataIndex: 'be_bcd_amt_inr', key: 'be_bcd_amt_inr', header: 'BE BCD Amt. (INR)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'BE SWS Amt. (INR)', dataIndex: 'be_sws_amt_inr', key: 'be_sws_amt_inr', header: 'BE SWS Amt. (INR)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'BE IGST Amt. (INR)', dataIndex: 'be_igst_amt_inr', key: 'be_igst_amt_inr', header: 'BE IGST Amt. (INR)', align: 'right', width: 205, render: t => formatToTwoDecimals(t) },
  { title: 'BE Total Duty (INR)', dataIndex: 'be_total_duty_inr', key: 'be_total_duty_inr', header: 'BE Total Duty (INR)', align: 'right', width: 210, render: t => formatToTwoDecimals(t) },
  { title: 'Interest (INR)', dataIndex: 'interest_inr', key: 'interest_inr', header: 'Interest (INR)', align: 'right', width: 170, render: t => formatToTwoDecimals(t) },
  { title: 'Penalty (INR)', dataIndex: 'penalty_inr', key: 'penalty_inr', header: 'Penalty (INR)', align: 'right', width: 160, render: t => formatToTwoDecimals(t) },
  { title: 'Fine (INR)', dataIndex: 'fine_inr', key: 'fine_inr', header: 'Fine (INR)', align: 'right', width: 140, render: t => formatToTwoDecimals(t) },
  { title: "BE Ass'able Amt. (INR)", dataIndex: 'be_assessable_amt_inr', key: 'be_assessable_amt_inr', header: "BE Ass'able Amt. (INR)", align: 'right', width: 240, render: t => formatToTwoDecimals(t) },
  { title: 'Total Amt. to Cus. (INR)', dataIndex: 'total_amt_to_customs_inr', key: 'total_amt_to_customs_inr', header: 'Total Amt. to Cus. (INR)', align: 'right', width: 260, render: t => formatToTwoDecimals(t) },
  { title: 'Ex. Rate on Sub.', dataIndex: 'ex_rate_on_submission', key: 'ex_rate_on_submission', header: 'Ex. Rate on Sub.', align: 'right', width: 190, render: t => formatToTwoDecimals(t) },
  { title: 'Ex. Rate on Assess.', dataIndex: 'ex_rate_on_assessment', key: 'ex_rate_on_assessment', header: 'Ex. Rate on Assess.', align: 'right', width: 210, render: t => formatToTwoDecimals(t) },
  { title: 'OOC Dt.', dataIndex: 'ooc_date', key: 'ooc_date', header: 'OOC Dt.', width: 110 },
  { title: 'Ex. Rate on Exam.', dataIndex: 'ex_rate_on_examination', key: 'ex_rate_on_examination', header: 'Ex. Rate on Exam.', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'Assess. Dt.', dataIndex: 'assessment_date', key: 'assessment_date', header: 'Assess. Dt.', width: 140 },
  { title: 'INW. Dt.', dataIndex: 'inward_date', key: 'inward_date', header: 'INW. Dt.', width: 120 },
  { title: 'USD Ex. Rate', dataIndex: 'usd_ex_rate', key: 'usd_ex_rate', header: 'USD Ex. Rate', align: 'right', width: 150, render: t => formatToTwoDecimals(t) },
  { title: "BE Ass'able Amt. (FCC)", dataIndex: 'be_assessable_amt_fcc', key: 'be_assessable_amt_fcc', header: "BE Ass'able Amt. (FCC)", align: 'right', width: 240, render: t => formatToTwoDecimals(t) },
  { title: 'BE BCD Amt. (FCC)', dataIndex: 'be_bcd_amt_fcc', key: 'be_bcd_amt_fcc', header: 'BE BCD Amt. (FCC)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'BE SWS Amt. (FCC)', dataIndex: 'be_sws_amt_fcc', key: 'be_sws_amt_fcc', header: 'BE SWS Amt. (FCC)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'Total Duty Paid (BCD+SWS) (FCC)', dataIndex: 'total_duty_paid_fcc', key: 'total_duty_paid_fcc', header: 'Total Duty Paid (BCD+SWS) (FCC)', align: 'right', width: 330, render: t => formatToTwoDecimals(t) },
  { title: 'Duty Debited to License (INR)', dataIndex: 'duty_debited_to_license_inr', key: 'duty_debited_to_license_inr', header: 'Duty Debited to License (INR)', align: 'right', width: 315, render: t => formatToTwoDecimals(t) },
  { title: 'Duty Amt Notification No', dataIndex: 'duty_amt_notification_no', key: 'duty_amt_notification_no', header: 'Duty Amt Notification No', width: 270 },
  { title: 'Duty Amount Sr. No.', dataIndex: 'duty_amt_sr_no', key: 'duty_amt_sr_no', header: 'Duty Amount Sr. No.', width: 220 },
  { title: 'BCD Duty Forgone (INR)', dataIndex: 'bcd_duty_forgone_inr', key: 'bcd_duty_forgone_inr', header: 'BCD Duty Forgone (INR)', align: 'right', width: 250, render: t => formatToTwoDecimals(t) },
  { title: 'Total BCD+SWS (INR)', dataIndex: 'total_bcd_sws_inr', key: 'total_bcd_sws_inr', header: 'Total BCD+SWS (INR)', align: 'right', width: 225, render: (t, record) => (String(record.transport_mode || '').toUpperCase() === 'SEZ' && !String(record.duty_amt_notification_no || '').trim()) ? '' : formatToTwoDecimals(t) },
  { title: 'Category', dataIndex: 'category', key: 'category', header: 'Category', width: 120 },
  { title: 'SWS Forgone (INR)', dataIndex: 'sws_forgone_inr', key: 'sws_forgone_inr', header: 'SWS Forgone (INR)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'Total Applicable Duty INR', dataIndex: 'total_applicable_duty_inr', key: 'total_applicable_duty_inr', header: 'Total Applicable Duty INR', align: 'right', width: 280, render: t => formatToTwoDecimals(t) },
  { title: 'BCD Duty Forgone (FCC)', dataIndex: 'bcd_duty_forgone_fcc', key: 'bcd_duty_forgone_fcc', header: 'BCD Duty Forgone (FCC)', align: 'right', width: 250, render: t => formatToTwoDecimals(t) },
];

// ─── Export Tab Columns ────────────────────────────────────────────────────────
const exportColumns = [
  { title: 'BU', dataIndex: 'bu', key: 'bu', header: 'BU', width: 160, fixed: 'left' },
  { title: 'Plant Name', dataIndex: 'plant_name', key: 'plant_name', header: 'Plant Name', width: 150, fixed: 'left' },
  { title: 'Month', dataIndex: 'month', key: 'month', header: 'Month', width: 90 },
  { title: 'SEZ/DTA', dataIndex: 'sez_dta', key: 'sez_dta', header: 'SEZ/DTA', width: 110 },
  { title: 'Org. Code', dataIndex: 'org_code', key: 'org_code', header: 'Org. Code', width: 130 },
  { title: 'Port Code', dataIndex: 'port_code', key: 'port_code', header: 'Port Code', width: 130 },
  { title: 'SHB No.', dataIndex: 'shb_no', key: 'shb_no', header: 'SHB No.', width: 115 },
  { title: 'SHB Dt.', dataIndex: 'shb_dt', key: 'shb_dt', header: 'SHB Dt.', width: 110 },
  { title: 'IEC/BR', dataIndex: 'iec_br', key: 'iec_br', header: 'IEC/BR', width: 110 },
  { title: 'Exporter Name & Address', dataIndex: 'exporter_name_address', key: 'exporter_name_address', header: 'Exporter Name & Address', width: 250 },
  { title: 'Consignee Name & Address', dataIndex: 'consignee_name_address', key: 'consignee_name_address', header: 'Consignee Name & Address', width: 260 },
  { title: 'Total FOB (INR)', dataIndex: 'total_fob_inr', key: 'total_fob_inr', header: 'Total FOB (INR)', align: 'right', width: 180, render: t => formatToTwoDecimals(t) },
  { title: 'Freight (INR)', dataIndex: 'freight_inr', key: 'freight_inr', header: 'Freight (INR)', align: 'right', width: 160, render: t => formatToTwoDecimals(t) },
  { title: 'Insurance (INR)', dataIndex: 'insurance_inr', key: 'insurance_inr', header: 'Insurance (INR)', align: 'right', width: 180, render: t => formatToTwoDecimals(t) },
  { title: 'Discount (INR)', dataIndex: 'discount_inr', key: 'discount_inr', header: 'Discount (INR)', align: 'right', width: 170, render: t => formatToTwoDecimals(t) },
  { title: 'Commission (INR)', dataIndex: 'commission_inr', key: 'commission_inr', header: 'Commission (INR)', align: 'right', width: 190, render: t => formatToTwoDecimals(t) },
  { title: 'Othr Deduction (INR)', dataIndex: 'othr_deduction_inr', key: 'othr_deduction_inr', header: 'Othr Deduction (INR)', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'Pkg. Charges (INR)', dataIndex: 'pkg_charges_inr', key: 'pkg_charges_inr', header: 'Pkg. Charges (INR)', align: 'right', width: 205, render: t => formatToTwoDecimals(t) },
  { title: 'Exp. Duty (INR)', dataIndex: 'exp_duty_inr', key: 'exp_duty_inr', header: 'Exp. Duty (INR)', align: 'right', width: 180, render: t => formatToTwoDecimals(t) },
  { title: 'Exp. Duty Cess (INR)', dataIndex: 'exp_duty_cess_inr', key: 'exp_duty_cess_inr', header: 'Exp. Duty Cess (INR)', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Amt. (INR)', dataIndex: 'dbk_amt_inr', key: 'dbk_amt_inr', header: 'DBK Amt. (INR)', align: 'right', width: 170, render: t => formatToTwoDecimals(t) },
  { title: 'IGST Refund Amt. (INR)', dataIndex: 'igst_refund_amt_inr', key: 'igst_refund_amt_inr', header: 'IGST Refund Amt. (INR)', align: 'right', width: 240, render: t => formatToTwoDecimals(t) },
  { title: 'IGST Cess Refund Amt. (INR)', dataIndex: 'igst_cess_refund_amt_inr', key: 'igst_cess_refund_amt_inr', header: 'IGST Cess Refund Amt. (INR)', align: 'right', width: 290, render: t => formatToTwoDecimals(t) },
  { title: 'Asses. Value (IGST) (INR)', dataIndex: 'asses_value_igst_inr', key: 'asses_value_igst_inr', header: 'Asses. Value (IGST) (INR)', align: 'right', width: 270, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Amt. (INR)', dataIndex: 'rodtep_amt_inr', key: 'rodtep_amt_inr', header: 'RoDTEP Amt. (INR)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'ROSCTL Amt. (INR)', dataIndex: 'rosctl_amt_inr', key: 'rosctl_amt_inr', header: 'ROSCTL Amt. (INR)', align: 'right', width: 195, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Eligible Amt (INR)', dataIndex: 'sbr_eligible_amt_inr', key: 'sbr_eligible_amt_inr', header: 'SBR Eligible Amt (INR)', align: 'right', width: 240, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Eligible Amt FCC', dataIndex: 'dbk_eligible_amt_fcc', key: 'dbk_eligible_amt_fcc', header: 'DBK Eligible Amt FCC', align: 'right', width: 230, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Eligible Amt FCC', dataIndex: 'rodtep_eligible_amt_fcc', key: 'rodtep_eligible_amt_fcc', header: 'RoDTEP Eligible Amt FCC', align: 'right', width: 260, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Eligible Amt FCC', dataIndex: 'sbr_eligible_amt_fcc', key: 'sbr_eligible_amt_fcc', header: 'SBR Eligible Amt FCC', align: 'right', width: 235, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Received Amt FCC', dataIndex: 'dbk_received_amt_fcc', key: 'dbk_received_amt_fcc', header: 'DBK Received Amt FCC', align: 'right', width: 230, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Received Amt FCC', dataIndex: 'rodtep_received_amt_fcc', key: 'rodtep_received_amt_fcc', header: 'RoDTEP Received Amt FCC', align: 'right', width: 260, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Received Amt FCC', dataIndex: 'sbr_received_amt_fcc', key: 'sbr_received_amt_fcc', header: 'SBR Received Amt FCC', align: 'right', width: 235, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Pending Amt FCC', dataIndex: 'dbk_pending_amt_fcc', key: 'dbk_pending_amt_fcc', header: 'DBK Pending Amt FCC', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Pending Amt FCC', dataIndex: 'rodtep_pending_amt_fcc', key: 'rodtep_pending_amt_fcc', header: 'RoDTEP Pending Amt FCC', align: 'right', width: 250, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Pending Amt FCC', dataIndex: 'sbr_pending_amt_fcc', key: 'sbr_pending_amt_fcc', header: 'SBR Pending Amt FCC', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Received Amt INR', dataIndex: 'dbk_received_amt_inr', key: 'dbk_received_amt_inr', header: 'DBK Received Amt INR', align: 'right', width: 230, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Received Amt INR', dataIndex: 'rodtep_received_amt_inr', key: 'rodtep_received_amt_inr', header: 'RoDTEP Received Amt INR', align: 'right', width: 260, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Received Amt INR', dataIndex: 'sbr_received_amt_inr', key: 'sbr_received_amt_inr', header: 'SBR Received Amt INR', align: 'right', width: 235, render: t => formatToTwoDecimals(t) },
  { title: 'DBK Pending Amt INR', dataIndex: 'dbk_pending_amt_inr', key: 'dbk_pending_amt_inr', header: 'DBK Pending Amt INR', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'RoDTEP Pending Amt INR', dataIndex: 'rodtep_pending_amt_inr', key: 'rodtep_pending_amt_inr', header: 'RoDTEP Pending Amt INR', align: 'right', width: 250, render: t => formatToTwoDecimals(t) },
  { title: 'SBR Pending Amt INR', dataIndex: 'sbr_pending_amt_inr', key: 'sbr_pending_amt_inr', header: 'SBR Pending Amt INR', align: 'right', width: 225, render: t => formatToTwoDecimals(t) },
  { title: 'SHB LEO Date', dataIndex: 'shb_leo_date', key: 'shb_leo_date', header: 'SHB LEO Date', align: 'center', width: 140, render: t => t ? formatDateToDDMMYY(t) : '' },
  { title: 'Sum of Total Refund Benefit FCC', dataIndex: 'sum_total_refund_benefit_fcc', key: 'sum_total_refund_benefit_fcc', header: 'Sum of Total Refund Benefit FCC', align: 'right', width: 325, render: t => formatToTwoDecimals(t) },
  { title: 'Sum of Total Received Benefit FCC', dataIndex: 'sum_total_received_benefit_fcc', key: 'sum_total_received_benefit_fcc', header: 'Sum of Total Received Benefit FCC', align: 'right', width: 340, render: t => formatToTwoDecimals(t) },
  { title: 'Sum of Total Pending Benefit FCC', dataIndex: 'sum_total_pending_benefit_fcc', key: 'sum_total_pending_benefit_fcc', header: 'Sum of Total Pending Benefit FCC', align: 'right', width: 330, render: t => formatToTwoDecimals(t) },
  { title: 'Ex. Rate', dataIndex: 'ex_rate', key: 'ex_rate', header: 'Ex. Rate', align: 'right', width: 120, render: t => formatToTwoDecimals(t) },
  { title: 'Sum of Total Refund benefit in INR', dataIndex: 'sum_total_refund_benefit_inr', key: 'sum_total_refund_benefit_inr', header: 'Sum of Total Refund benefit in INR', align: 'right', width: 330, render: t => formatToTwoDecimals(t) },
  { title: 'Sum of Total Received Benefit in INR', dataIndex: 'sum_total_received_benefit_inr', key: 'sum_total_received_benefit_inr', header: 'Sum of Total Received Benefit in INR', align: 'right', width: 345, render: t => formatToTwoDecimals(t) },
  { title: 'Sum of Total Pending Benefit in INR', dataIndex: 'sum_total_pending_benefit_inr', key: 'sum_total_pending_benefit_inr', header: 'Sum of Total Pending Benefit in INR', align: 'right', width: 335, render: t => formatToTwoDecimals(t) },
  { title: 'EGM No', dataIndex: 'egm_no', key: 'egm_no', header: 'EGM No', width: 130 },
  { title: 'EGM Dtd.', dataIndex: 'egm_date', key: 'egm_date', header: 'EGM Dtd.', width: 120, render: t => t ? formatDateToDDMMYY(t) : '' },
  { title: 'EGM Remarks', dataIndex: 'egm_remarks', key: 'egm_remarks', header: 'EGM Remarks', width: 140 },
];

// ─── Helper ────────────────────────────────────────────────────────────────────
function formatDateToDDMMYY(dateString) {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = String(date.getFullYear()).slice(-2);
  return `${d}/${m}/${y}`;
}

function getDateOnly(dateString) {
  if (dateString && dateString.length !== 0) return new Date(dateString);
  return '';
}

function applyExcelHeaderStyle(worksheet) {
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC000' } };
    cell.alignment = { vertical: 'middle', wrapText: true };
  });
}

// ─── Component ─────────────────────────────────────────────────────────────────
const DutySavingReport = () => {
  const tableStyles = `
    .duty-saving-table .ant-table-thead > tr > th {
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: unset !important;
      min-width: fit-content !important;
    }
    .duty-saving-table .ant-table-tbody > tr > td {
      white-space: nowrap;
    }
    .duty-saving-table .ant-table-container {
      overflow-x: auto !important;
    }
    .duty-saving-table .ant-table-header {
      overflow: hidden !important;
    }
    .duty-saving-table .ant-table-sticky-holder {
      overflow: hidden !important;
    }
  `;
  const location = useLocation();
  const userRole = localStorage.getItem('role');

  const [selectedIEC, setSelectedIEC] = useState(localStorage.getItem('iec_no'));
  const [selectedIECName, setSelectedIECName] = useState(localStorage.getItem('name'));
  const [IECOptions, setIECOptions] = useState([]);
  const [branchCodeNames, setBranchCodeNames] = useState([]);
  const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);
  const [billNo, setBillNo] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [activeTab, setActiveTab] = useState('import');

  const importVisibility = useColumnVisibility('DutySavingImportReport', importColumns);
  const exportVisibility = useColumnVisibility('DutySavingExportReport', exportColumns);

  const [importData, setImportData] = useState([]);
  const [isImportLoading, setIsImportLoading] = useState(false);

  const [exportData, setExportData] = useState([]);
  const [isExportLoading, setIsExportLoading] = useState(false);

  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  const currentYear = dayjs().year();
  const defaultFrom = dayjs(`${currentYear}-01-01`);
  const defaultTo = dayjs(`${currentYear}-12-31`);

  const [dates, setDates] = useState(() => {
    if (location.state?.passedDates?.length === 2) {
      return [dayjs(location.state.passedDates[0]), dayjs(location.state.passedDates[1])];
    }
    return [defaultFrom, defaultTo];
  });

  // ─── Data Fetching ──────────────────────────────────────────────────────────
  const buildFilters = () => ({
    from_date: dates?.[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
    to_date: dates?.[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null,
    bill_no: billNo.trim() || null,
    br_code: selectedBranchCodes?.length ? selectedBranchCodes : null,
  });

  const fetchImportData = async () => {
    try {
      setIsImportLoading(true);
      const response = await getImportDutyReportService(selectedIEC, buildFilters());
      setImportData(response || []);
    } catch (error) {
      console.error('Error fetching import duty data:', error);
      message.error('Failed to fetch Import Duty data');
    } finally {
      setIsImportLoading(false);
    }
  };

  const fetchExportData = async () => {
    try {
      setIsExportLoading(true);
      const response = await getExportIncentiveReportService(selectedIEC, buildFilters());
      setExportData(response || []);
    } catch (error) {
      console.error('Error fetching export incentive data:', error);
      message.error('Failed to fetch Export Incentive data');
    } finally {
      setIsExportLoading(false);
    }
  };

  const fetchBranchCodeNames = async (iec) => {
    try {
      const response = await getBRCorelationService(iec);
      if (response) setBranchCodeNames(response);
    } catch (error) {
      console.error('Error fetching branch codes:', error);
    }
  };

  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);
      if (response?.data) {
        const options = response.data.map((item, index) => ({
          value: `${item.iec_no};${item.fullname}`,
          label: `${item.iec_no} (${item.fullname})`,
          key: index,
        }));
        setIECOptions(options);
      }
    } catch (err) {
      message.error('Failed to load IEC list');
    }
  };

  // ─── useEffect 1: on mount ─────────────────────────────────────────────────
  // Guard added: only call fetchBranchCodeNames if selectedIEC is not null
  // (prevents superadmin from firing a request with null IEC on first load)
  useEffect(() => {
    if (userRole === 'superadmin' || userRole === 'group_head') {
      getAdminIEC();
    }
    if (userRole === 'admin' || userRole === 'user') {
      fetchImportData();
      fetchExportData();
    }
    if (selectedIEC) {
      fetchBranchCodeNames(selectedIEC);
    }
  }, []);

  // ─── useEffect 2: re-fetch branch codes when superadmin selects an IEC ────
  // This was missing — branch codes never updated after IEC selection
  useEffect(() => {
    if (selectedIEC) {
      fetchBranchCodeNames(selectedIEC);
    }
  }, [selectedIEC]);

  // ─── Handlers ───────────────────────────────────────────────────────────────
  const handleDateChange = (value) => {
    setDates(value || []);
    if (value && value.length === 2) {
      const [from_date, to_date] = value;
      if (!from_date || !to_date) { setIsValid(false); return; }
      if (to_date.isAfter(from_date.add(1, 'year'))) {
        message.error('The selected duration should not exceed 1 year.');
        setIsValid(false);
        return;
      }
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    if (!selectedIEC) { message.error('Please select an IEC'); return; }
    if (dates.length === 2 && isValid) {
      fetchImportData();
      fetchExportData();
    } else {
      message.error('Please select a valid date range');
    }
  };

  const handleIECSelection = (val) => {
    if (val) {
      const [iec_no, iec_name] = val.split(';');
      setSelectedIEC(iec_no);
      setSelectedIECName(iec_name);
    } else {
      setSelectedIEC(null);
      setSelectedIECName('');
    }
  };

  const handleBranchCodeSelection = (values) => {
    setSelectedBranchCodes(values);
  };

  // ─── Excel Export ───────────────────────────────────────────────────────────
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    const summarySheet = workbook.addWorksheet('Summary');

    // Use the same normalized BOE values for both Summary and Import Data so
    // the two sheets always reconcile, even for historical rows whose stored
    // FCC columns were populated with a different conversion rule.
    const normalizedImportData = importData.map(obj => {
      const usdExRate = Number(obj.usd_ex_rate) || 0;
      const beAssessInr = Number(obj.be_assessable_amt_inr) || 0;
      const beBcdInr = Number(obj.be_bcd_amt_inr) || 0;
      const beSwsInr = Number(obj.be_sws_amt_inr) || 0;
      const licDebitInr = Number(obj.duty_debited_to_license_inr) || 0;
      const bcdForgoneInr = Number(obj.bcd_duty_forgone_inr) || 0;
      // "SEZ" here means an actual SEZ-mode import (mode = SEZ) — NOT the
      // notification-derived 'SEZ Benefit' category, which also covers ordinary
      // blank-notification DTA imports that really did pay BCD/SWS. Only true
      // SEZ imports show '-' / no duty paid; DTA imports keep their paid duty.
      const isSezMode = String(obj.transport_mode || '').toUpperCase() === 'SEZ';
      const hasNotif = String(obj.duty_amt_notification_no || '').trim() !== '';

      return {
        ...obj,
        be_assessable_amt_fcc: usdExRate > 0 ? beAssessInr / usdExRate : 0,
        be_bcd_amt_fcc: usdExRate > 0 ? beBcdInr / usdExRate : 0,
        be_sws_amt_fcc: usdExRate > 0 ? beSwsInr / usdExRate : 0,
        total_duty_paid_fcc: isSezMode || usdExRate <= 0
          ? 0
          : (beBcdInr + beSwsInr) / usdExRate,
        // Same SEZ-mode zeroing as total_duty_paid_fcc, just without the
        // exchange-rate dependency — INR needs no rate to exist.
        total_duty_paid_inr: isSezMode ? 0 : (beBcdInr + beSwsInr),
        // Client criteria: Total BCD+SWS is blank ('-') only for a SEZ-mode
        // import with a blank notification; otherwise it is BE BCD + BE SWS.
        total_bcd_sws_inr: (isSezMode && !hasNotif) ? null : beBcdInr + beSwsInr,
        // For SEZ the BCD is already inside the forgone amount, so drop the BCD
        // term to avoid double counting (matches the backend).
        total_applicable_duty_inr: (isSezMode ? 0 : beBcdInr) + licDebitInr + bcdForgoneInr,
        bcd_duty_forgone_fcc: usdExRate > 0 ? bcdForgoneInr / usdExRate : 0,
      };
    });

    const buMap = {};
    normalizedImportData.forEach(row => {
      const bu = row.business_unit || 'Others';
      if (!buMap[bu]) buMap[bu] = {
        assessable_amt: 0, duty_paid: 0, refund: 0, dbk: 0, rodtep: 0, sbr: 0,
        fta_forgone: 0, customs_notif_forgone: 0, sez_forgone: 0,
        fta_forgone_fcc: 0, customs_notif_forgone_fcc: 0, sez_forgone_fcc: 0,
        rodtep_inr: 0, dbk_inr: 0, sbr_inr: 0,
        assessable_amt_inr: 0, duty_paid_inr: 0, refund_inr: 0,
        dbk_received: 0, rodtep_received: 0, sbr_received: 0,
        dbk_pending: 0, rodtep_pending: 0, sbr_pending: 0,
        dbk_received_inr: 0, rodtep_received_inr: 0, sbr_received_inr: 0,
        dbk_pending_inr: 0, rodtep_pending_inr: 0, sbr_pending_inr: 0,
      };
      buMap[bu].assessable_amt += Number(row.be_assessable_amt_fcc) || 0;
      buMap[bu].duty_paid += Number(row.total_duty_paid_fcc) || 0;
      buMap[bu].assessable_amt_inr += Number(row.be_assessable_amt_inr) || 0;
      buMap[bu].duty_paid_inr += Number(row.total_duty_paid_inr) || 0;
      const forgone = Number(row.bcd_duty_forgone_inr) || 0;
      const forgoneFcc = Number(row.bcd_duty_forgone_fcc) || 0;
      if (row.category === 'FTA') {
        buMap[bu].fta_forgone += forgone;
        buMap[bu].fta_forgone_fcc += forgoneFcc;
      } else if (row.category === 'Customs Notification') {
        buMap[bu].customs_notif_forgone += forgone;
        buMap[bu].customs_notif_forgone_fcc += forgoneFcc;
      } else if (row.category === 'SEZ Benefit') {
        buMap[bu].sez_forgone += forgone;
        buMap[bu].sez_forgone_fcc += forgoneFcc;
      }
    });

    exportData.forEach(row => {
      const bu = row.bu || 'Others';
      if (!buMap[bu]) buMap[bu] = {
        assessable_amt: 0, duty_paid: 0, refund: 0, dbk: 0, rodtep: 0, sbr: 0,
        fta_forgone: 0, customs_notif_forgone: 0, sez_forgone: 0,
        fta_forgone_fcc: 0, customs_notif_forgone_fcc: 0, sez_forgone_fcc: 0,
        rodtep_inr: 0, dbk_inr: 0, sbr_inr: 0,
        assessable_amt_inr: 0, duty_paid_inr: 0, refund_inr: 0,
        dbk_received: 0, rodtep_received: 0, sbr_received: 0,
        dbk_pending: 0, rodtep_pending: 0, sbr_pending: 0,
        dbk_received_inr: 0, rodtep_received_inr: 0, sbr_received_inr: 0,
        dbk_pending_inr: 0, rodtep_pending_inr: 0, sbr_pending_inr: 0,
      };
      buMap[bu].refund += Number(row.sum_total_refund_benefit_fcc) || 0;
      buMap[bu].refund_inr += Number(row.sum_total_refund_benefit_inr) || 0;
      buMap[bu].dbk += Number(row.dbk_eligible_amt_fcc) || 0;
      buMap[bu].rodtep += Number(row.rodtep_eligible_amt_fcc) || 0;
      buMap[bu].sbr += Number(row.sbr_eligible_amt_fcc) || 0;
      buMap[bu].rodtep_inr += Number(row.rodtep_amt_inr) || 0;
      buMap[bu].dbk_inr += Number(row.dbk_amt_inr) || 0;
      buMap[bu].sbr_inr += Number(row.sbr_eligible_amt_inr) || 0;
      buMap[bu].dbk_received += Number(row.dbk_received_amt_fcc) || 0;
      buMap[bu].rodtep_received += Number(row.rodtep_received_amt_fcc) || 0;
      buMap[bu].sbr_received += Number(row.sbr_received_amt_fcc) || 0;
      buMap[bu].dbk_pending += Number(row.dbk_pending_amt_fcc) || 0;
      buMap[bu].rodtep_pending += Number(row.rodtep_pending_amt_fcc) || 0;
      buMap[bu].sbr_pending += Number(row.sbr_pending_amt_fcc) || 0;
      buMap[bu].dbk_received_inr += Number(row.dbk_received_amt_inr) || 0;
      buMap[bu].rodtep_received_inr += Number(row.rodtep_received_amt_inr) || 0;
      buMap[bu].sbr_received_inr += Number(row.sbr_received_amt_inr) || 0;
      buMap[bu].dbk_pending_inr += Number(row.dbk_pending_amt_inr) || 0;
      buMap[bu].rodtep_pending_inr += Number(row.rodtep_pending_amt_inr) || 0;
      buMap[bu].sbr_pending_inr += Number(row.sbr_pending_amt_inr) || 0;
    });

    const buKeys = Object.keys(buMap).sort();

    summarySheet.getColumn('A').width = 25;
    summarySheet.getColumn('B').width = 25;
    summarySheet.getColumn('C').width = 25;
    summarySheet.getColumn('D').width = 25;
    summarySheet.getColumn('E').width = 25;
    summarySheet.getColumn('F').width = 20;
    summarySheet.getColumn('G').width = 20;
    summarySheet.getColumn('H').width = 20;
    summarySheet.getColumn('I').width = 20;
    summarySheet.getColumn('J').width = 20;
    summarySheet.getColumn('K').width = 20;
    summarySheet.getColumn('L').width = 15;
    summarySheet.getColumn('M').width = 15;

    let currentRow = 1;

    const applyBorders = (startCol, endCol, startRow, endRow) => {
      for (let r = startRow; r <= endRow; r++) {
        for (let c = startCol; c <= endCol; c++) {
          const char = String.fromCharCode(64 + c);
          const cell = summarySheet.getCell(`${char}${r}`);
          cell.border = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' },
          };
        }
      }
    };

    // Table 1
    summarySheet.getCell(`A${currentRow}`).value = 'Total Refund benefit';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    summarySheet.getCell(`A${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    currentRow++;
    const t1Start = currentRow;
    summarySheet.getCell(`A${currentRow}`).value = 'BU';
    summarySheet.getCell(`B${currentRow}`).value = 'Sum of Sum of Total Refund benefit in FCC';
    ['A', 'B'].forEach(col => {
      const cell = summarySheet.getCell(`${col}${currentRow}`);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    });
    currentRow++;
    const table1RowMap = {};
    buKeys.forEach(bu => {
      summarySheet.getCell(`A${currentRow}`).value = bu;
      summarySheet.getCell(`B${currentRow}`).value = buMap[bu].refund;
      summarySheet.getCell(`B${currentRow}`).numFmt = '#,##0.00';
      table1RowMap[bu] = currentRow;
      currentRow++;
    });
    summarySheet.getCell(`A${currentRow}`).value = 'Grand Total';
    summarySheet.getCell(`B${currentRow}`).value = buKeys.length > 0
      ? { formula: `SUM(B${t1Start + 1}:B${currentRow - 1})` } : 0;
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    summarySheet.getCell(`B${currentRow}`).font = { bold: true };
    summarySheet.getCell(`B${currentRow}`).numFmt = '#,##0.00';
    applyBorders(1, 2, t1Start, currentRow);
    currentRow += 3;

    // Table 2
    summarySheet.getCell(`A${currentRow}`).value = 'Effective Duty Rate net of incentive';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    summarySheet.getCell(`A${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92D050' } };
    currentRow++;
    const t2Start = currentRow;
    summarySheet.getCell(`A${currentRow}`).value = 'Business Unit';
    summarySheet.getCell(`B${currentRow}`).value = "Sum of BE Ass'able Amt. (FCC)";
    summarySheet.getCell(`C${currentRow}`).value = 'Sum of Total Duty Paid (BCD+SWS) (FCC)';
    summarySheet.getCell(`D${currentRow}`).value = 'Sum of Sum of Total Refund benefit in FCC';
    summarySheet.getCell(`E${currentRow}`).value = 'Sum of Net Duty (FCC)';
    summarySheet.getCell(`F${currentRow}`).value = 'Duty Rate';
    for (let col = 1; col <= 6; col++) {
      const char = String.fromCharCode(64 + col);
      const cell = summarySheet.getCell(`${char}${currentRow}`);
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      if (col <= 3) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      else cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA9D08E' } };
    }
    currentRow++;
    buKeys.forEach(bu => {
      summarySheet.getCell(`A${currentRow}`).value = bu;
      summarySheet.getCell(`B${currentRow}`).value = buMap[bu].assessable_amt;
      summarySheet.getCell(`C${currentRow}`).value = buMap[bu].duty_paid;
      const t1Row = table1RowMap[bu];
      summarySheet.getCell(`D${currentRow}`).value = t1Row ? { formula: `B${t1Row}` } : 0;
      summarySheet.getCell(`E${currentRow}`).value = { formula: `C${currentRow}-D${currentRow}` };
      summarySheet.getCell(`F${currentRow}`).value = { formula: `IF(B${currentRow}<>0, E${currentRow}/B${currentRow}, 0)` };
      ['B', 'C', 'D', 'E'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00');
      summarySheet.getCell(`F${currentRow}`).numFmt = '0.00%';
      currentRow++;
    });
    summarySheet.getCell(`A${currentRow}`).value = 'Grand Total';
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E'].forEach(c => {
        summarySheet.getCell(`${c}${currentRow}`).value = { formula: `SUM(${c}${t2Start + 1}:${c}${currentRow - 1})` };
      });
    } else {
      ['B', 'C', 'D', 'E'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).value = 0);
    }
    summarySheet.getCell(`F${currentRow}`).value = { formula: `IF(B${currentRow}<>0, E${currentRow}/B${currentRow}, 0)` };
    ['A', 'B', 'C', 'D', 'E', 'F'].forEach(c => {
      summarySheet.getCell(`${c}${currentRow}`).font = { bold: true };
      if (c !== 'A' && c !== 'F') summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00';
    });
    summarySheet.getCell(`F${currentRow}`).numFmt = '0.00%';
    applyBorders(1, 6, t2Start, currentRow);
    currentRow += 3;

    // Table 3
    summarySheet.getCell(`A${currentRow}`).value = 'Export Incentive DBK Air + SBR and Rodtep (Amount in-M$)';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    summarySheet.getCell(`A${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92D050' } };
    currentRow++;
    const t3Start = currentRow;
    summarySheet.getCell(`A${currentRow}`).value = 'BU';
    summarySheet.getCell(`B${currentRow}`).value = 'Sum of DBK Eligible Amt FCC';
    summarySheet.getCell(`C${currentRow}`).value = 'Sum of RoDTEP Eligible Amt FCC';
    summarySheet.getCell(`D${currentRow}`).value = 'Sum of SBR Eligible Amt FCC';
    ['A', 'B', 'C', 'D'].forEach(col => {
      const cell = summarySheet.getCell(`${col}${currentRow}`);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    });
    currentRow++;
    buKeys.forEach(bu => {
      summarySheet.getCell(`A${currentRow}`).value = bu;
      summarySheet.getCell(`B${currentRow}`).value = buMap[bu].dbk;
      summarySheet.getCell(`C${currentRow}`).value = buMap[bu].rodtep;
      summarySheet.getCell(`D${currentRow}`).value = buMap[bu].sbr;
      ['B', 'C', 'D'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00');
      currentRow++;
    });
    summarySheet.getCell(`A${currentRow}`).value = 'Grand Total';
    if (buKeys.length > 0) {
      ['B', 'C', 'D'].forEach(c => {
        summarySheet.getCell(`${c}${currentRow}`).value = { formula: `SUM(${c}${t3Start + 1}:${c}${currentRow - 1})` };
      });
    } else {
      ['B', 'C', 'D'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).value = 0);
    }
    ['A', 'B', 'C', 'D'].forEach(c => {
      summarySheet.getCell(`${c}${currentRow}`).font = { bold: true };
      if (c !== 'A') summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00';
    });
    applyBorders(1, 4, t3Start, currentRow);
    currentRow += 3;

    // Table 4 — Total Trade Benefits
    summarySheet.getCell(`A${currentRow}`).value = 'Total Trade Benefits';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true, size: 13 };
    summarySheet.getCell(`A${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    currentRow++;
    const t4Start = currentRow;
    const t4Headers = ['BU NAME', 'FTA', 'Customs Notification', 'SEZ Benefits', 'Sum of RODTEP', 'Sum of DBK', 'Sum of DBK SBR', 'Sum of Benefits Grand total'];
    t4Headers.forEach((h, i) => {
      const col = String.fromCharCode(65 + i);
      const cell = summarySheet.getCell(`${col}${currentRow}`);
      cell.value = h;
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
    });
    currentRow++;
    buKeys.forEach(bu => {
      const r = buMap[bu];
      ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach((c, i) => {
        const cell = summarySheet.getCell(`${c}${currentRow}`);
        if (i === 0) {
          cell.value = bu;
        } else if (i === 1) {
          cell.value = r.fta_forgone_fcc || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 2) {
          cell.value = r.customs_notif_forgone_fcc || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 3) {
          cell.value = r.sez_forgone_fcc || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 4) {
          cell.value = r.rodtep || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 5) {
          cell.value = r.dbk || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 6) {
          cell.value = r.sbr || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 7) {
          cell.value = { formula: `B${currentRow}+C${currentRow}+D${currentRow}+E${currentRow}+F${currentRow}+G${currentRow}` };
          cell.numFmt = '#,##0.00';
        }
      });
      currentRow++;
    });
    // Grand Total row
    summarySheet.getCell(`A${currentRow}`).value = 'Grand Total';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach(c => {
        summarySheet.getCell(`${c}${currentRow}`).value = { formula: `SUM(${c}${t4Start + 1}:${c}${currentRow - 1})` };
        summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00';
        summarySheet.getCell(`${c}${currentRow}`).font = { bold: true };
      });
    } else {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach(c => {
        summarySheet.getCell(`${c}${currentRow}`).value = 0;
        summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00';
        summarySheet.getCell(`${c}${currentRow}`).font = { bold: true };
      });
    }
    applyBorders(1, 8, t4Start, currentRow);
    const t4GrandTotalRow = currentRow;
    currentRow += 3;

    // Table 5 — Total Trade Benefits in Millions of USD.
    // A vertical restatement of Table 4's Grand Total row; each value is that
    // grand total (already in FCC/USD) divided by 1,000,000 so it reads in M$.
    summarySheet.getCell(`A${currentRow}`).value = 'Particular';
    summarySheet.getCell(`B${currentRow}`).value = 'Amount in-M$';
    ['A', 'B'].forEach(col => {
      const cell = summarySheet.getCell(`${col}${currentRow}`);
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
    });
    currentRow++;
    const t5Start = currentRow - 1;
    // label -> Table 4 grand-total column that feeds it
    const t5Rows = [
      ['RODTEP', 'E'],
      ['Duty DBK Air', 'F'],
      ['Duty DBK SBR', 'G'],
      ['SEZ Benefits', 'D'],
      ['FTA Benefits', 'B'],
      ['Customs Notification Benefits', 'C'],
    ];
    t5Rows.forEach(([label, srcCol]) => {
      summarySheet.getCell(`A${currentRow}`).value = label;
      summarySheet.getCell(`B${currentRow}`).value = { formula: `${srcCol}${t4GrandTotalRow}/1000000` };
      summarySheet.getCell(`B${currentRow}`).numFmt = '$ #,##0.00';
      currentRow++;
    });
    summarySheet.getCell(`A${currentRow}`).value = 'Grand total';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    summarySheet.getCell(`B${currentRow}`).value = { formula: `SUM(B${t5Start + 1}:B${currentRow - 1})` };
    summarySheet.getCell(`B${currentRow}`).numFmt = '$ #,##0.00';
    summarySheet.getCell(`B${currentRow}`).font = { bold: true };
    applyBorders(1, 2, t5Start, currentRow);
    currentRow += 3;

    // Table 6 — Export Reports: RoDTEP/DBK/SBR Eligible vs Received vs Pending,
    // plus a Received/Eligible % column per incentive (guarded against /0,
    // unlike the reference file's bare division which throws #DIV/0!).
    summarySheet.getCell(`A${currentRow}`).value = 'Export Reports';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true, size: 13 };
    summarySheet.getCell(`A${currentRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    currentRow++;
    const t6Start = currentRow;
    const t6Headers = [
      'Business Unit',
      'Sum of RoDTEP Eligible Amt FCC', 'Sum of RoDTEP Received Amt FCC', 'Sum of RoDTEP Pending Amt FCC',
      'Sum of DBK Eligible Amt FCC', 'Sum of DBK Received Amt FCC', 'Sum of DBK Pending Amt FCC',
      'Sum of SBR Eligible Amt FCC', 'Sum of SBR Received Amt FCC', 'Sum of SBR Pending Amt FCC',
      'Rodtep in %', 'DBK in %', 'SBR in %',
    ];
    t6Headers.forEach((h, i) => {
      const col = String.fromCharCode(65 + i);
      const cell = summarySheet.getCell(`${col}${currentRow}`);
      cell.value = h;
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
    });
    currentRow++;
    buKeys.forEach(bu => {
      const r = buMap[bu];
      summarySheet.getCell(`A${currentRow}`).value = bu;
      summarySheet.getCell(`B${currentRow}`).value = r.rodtep || 0;
      summarySheet.getCell(`C${currentRow}`).value = r.rodtep_received || 0;
      summarySheet.getCell(`D${currentRow}`).value = r.rodtep_pending || 0;
      summarySheet.getCell(`E${currentRow}`).value = r.dbk || 0;
      summarySheet.getCell(`F${currentRow}`).value = r.dbk_received || 0;
      summarySheet.getCell(`G${currentRow}`).value = r.dbk_pending || 0;
      summarySheet.getCell(`H${currentRow}`).value = r.sbr || 0;
      summarySheet.getCell(`I${currentRow}`).value = r.sbr_received || 0;
      summarySheet.getCell(`J${currentRow}`).value = r.sbr_pending || 0;
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00');
      summarySheet.getCell(`K${currentRow}`).value = { formula: `IF(B${currentRow}<>0, C${currentRow}/B${currentRow}, 0)` };
      summarySheet.getCell(`L${currentRow}`).value = { formula: `IF(E${currentRow}<>0, F${currentRow}/E${currentRow}, 0)` };
      summarySheet.getCell(`M${currentRow}`).value = { formula: `IF(H${currentRow}<>0, I${currentRow}/H${currentRow}, 0)` };
      ['K', 'L', 'M'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).numFmt = '0.00%');
      currentRow++;
    });
    summarySheet.getCell(`A${currentRow}`).value = 'Grand Total';
    summarySheet.getCell(`A${currentRow}`).font = { bold: true };
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => {
        summarySheet.getCell(`${c}${currentRow}`).value = { formula: `SUM(${c}${t6Start + 1}:${c}${currentRow - 1})` };
      });
    } else {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => summarySheet.getCell(`${c}${currentRow}`).value = 0);
    }
    summarySheet.getCell(`K${currentRow}`).value = { formula: `IF(B${currentRow}<>0, C${currentRow}/B${currentRow}, 0)` };
    summarySheet.getCell(`L${currentRow}`).value = { formula: `IF(E${currentRow}<>0, F${currentRow}/E${currentRow}, 0)` };
    summarySheet.getCell(`M${currentRow}`).value = { formula: `IF(H${currentRow}<>0, I${currentRow}/H${currentRow}, 0)` };
    ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'].forEach(c => {
      summarySheet.getCell(`${c}${currentRow}`).font = { bold: true };
      if (['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].includes(c)) summarySheet.getCell(`${c}${currentRow}`).numFmt = '#,##0.00';
      if (['K', 'L', 'M'].includes(c)) summarySheet.getCell(`${c}${currentRow}`).numFmt = '0.00%';
    });
    applyBorders(1, 13, t6Start, currentRow);

    // ─── Summary INR sheet — Tables 1-4 mirrored in INR, plus Table 5 (Export
    // Reports: Eligible/Received/Pending + %). "Amount in-M$" (FCC Table 5) is
    // a dollar-specific restatement that doesn't translate to INR, so it has no
    // equivalent here — the reference report's own Summary-INR sheet omits it too.
    const summarySheetInr = workbook.addWorksheet('Summary INR');
    summarySheetInr.getColumn('A').width = 25;
    summarySheetInr.getColumn('B').width = 25;
    summarySheetInr.getColumn('C').width = 25;
    summarySheetInr.getColumn('D').width = 25;
    summarySheetInr.getColumn('E').width = 25;
    summarySheetInr.getColumn('F').width = 20;
    summarySheetInr.getColumn('G').width = 20;
    summarySheetInr.getColumn('H').width = 20;
    summarySheetInr.getColumn('I').width = 20;
    summarySheetInr.getColumn('J').width = 20;
    summarySheetInr.getColumn('K').width = 20;
    summarySheetInr.getColumn('L').width = 15;
    summarySheetInr.getColumn('M').width = 15;

    const applyBordersInr = (startCol, endCol, startRow, endRow) => {
      for (let r = startRow; r <= endRow; r++) {
        for (let c = startCol; c <= endCol; c++) {
          const char = String.fromCharCode(64 + c);
          const cell = summarySheetInr.getCell(`${char}${r}`);
          cell.border = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' },
          };
        }
      }
    };

    let inrRow = 1;

    // Table 1 (INR) — Total Refund Benefit
    summarySheetInr.getCell(`A${inrRow}`).value = 'Total Refund benefit';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    summarySheetInr.getCell(`A${inrRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    inrRow++;
    const it1Start = inrRow;
    summarySheetInr.getCell(`A${inrRow}`).value = 'BU';
    summarySheetInr.getCell(`B${inrRow}`).value = 'Sum of Sum of Total Refund benefit in INR';
    ['A', 'B'].forEach(col => {
      const cell = summarySheetInr.getCell(`${col}${inrRow}`);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    });
    inrRow++;
    const inrTable1RowMap = {};
    buKeys.forEach(bu => {
      summarySheetInr.getCell(`A${inrRow}`).value = bu;
      summarySheetInr.getCell(`B${inrRow}`).value = buMap[bu].refund_inr;
      summarySheetInr.getCell(`B${inrRow}`).numFmt = '#,##0.00';
      inrTable1RowMap[bu] = inrRow;
      inrRow++;
    });
    summarySheetInr.getCell(`A${inrRow}`).value = 'Grand Total';
    summarySheetInr.getCell(`B${inrRow}`).value = buKeys.length > 0
      ? { formula: `SUM(B${it1Start + 1}:B${inrRow - 1})` } : 0;
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    summarySheetInr.getCell(`B${inrRow}`).font = { bold: true };
    summarySheetInr.getCell(`B${inrRow}`).numFmt = '#,##0.00';
    applyBordersInr(1, 2, it1Start, inrRow);
    inrRow += 3;

    // Table 2 (INR) — Effective Duty Rate net of incentive
    summarySheetInr.getCell(`A${inrRow}`).value = 'Effective Duty Rate net of incentive';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    summarySheetInr.getCell(`A${inrRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92D050' } };
    inrRow++;
    const it2Start = inrRow;
    summarySheetInr.getCell(`A${inrRow}`).value = 'Business Unit';
    summarySheetInr.getCell(`B${inrRow}`).value = "Sum of BE Ass'able Amt. (INR)";
    summarySheetInr.getCell(`C${inrRow}`).value = 'Sum of Total BCD+SWS (INR)';
    summarySheetInr.getCell(`D${inrRow}`).value = 'Sum of Sum of Total Refund benefit in INR';
    summarySheetInr.getCell(`E${inrRow}`).value = 'Sum of Net Duty (INR)';
    summarySheetInr.getCell(`F${inrRow}`).value = 'Duty Rate';
    for (let col = 1; col <= 6; col++) {
      const char = String.fromCharCode(64 + col);
      const cell = summarySheetInr.getCell(`${char}${inrRow}`);
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      if (col <= 3) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      else cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA9D08E' } };
    }
    inrRow++;
    buKeys.forEach(bu => {
      summarySheetInr.getCell(`A${inrRow}`).value = bu;
      summarySheetInr.getCell(`B${inrRow}`).value = buMap[bu].assessable_amt_inr;
      summarySheetInr.getCell(`C${inrRow}`).value = buMap[bu].duty_paid_inr;
      const it1Row = inrTable1RowMap[bu];
      summarySheetInr.getCell(`D${inrRow}`).value = it1Row ? { formula: `B${it1Row}` } : 0;
      summarySheetInr.getCell(`E${inrRow}`).value = { formula: `C${inrRow}-D${inrRow}` };
      summarySheetInr.getCell(`F${inrRow}`).value = { formula: `IF(B${inrRow}<>0, E${inrRow}/B${inrRow}, 0)` };
      ['B', 'C', 'D', 'E'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00');
      summarySheetInr.getCell(`F${inrRow}`).numFmt = '0.00%';
      inrRow++;
    });
    summarySheetInr.getCell(`A${inrRow}`).value = 'Grand Total';
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E'].forEach(c => {
        summarySheetInr.getCell(`${c}${inrRow}`).value = { formula: `SUM(${c}${it2Start + 1}:${c}${inrRow - 1})` };
      });
    } else {
      ['B', 'C', 'D', 'E'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).value = 0);
    }
    summarySheetInr.getCell(`F${inrRow}`).value = { formula: `IF(B${inrRow}<>0, E${inrRow}/B${inrRow}, 0)` };
    ['A', 'B', 'C', 'D', 'E', 'F'].forEach(c => {
      summarySheetInr.getCell(`${c}${inrRow}`).font = { bold: true };
      if (c !== 'A' && c !== 'F') summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00';
    });
    summarySheetInr.getCell(`F${inrRow}`).numFmt = '0.00%';
    applyBordersInr(1, 6, it2Start, inrRow);
    inrRow += 3;

    // Table 3 (INR) — Export Incentive DBK Air + SBR and Rodtep
    summarySheetInr.getCell(`A${inrRow}`).value = 'Export Incentive DBK Air + SBR and Rodtep';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    summarySheetInr.getCell(`A${inrRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92D050' } };
    inrRow++;
    const it3Start = inrRow;
    summarySheetInr.getCell(`A${inrRow}`).value = 'BU';
    summarySheetInr.getCell(`B${inrRow}`).value = 'Sum of DBK Amt. (INR)';
    summarySheetInr.getCell(`C${inrRow}`).value = 'Sum of RoDTEP Amt. (INR)';
    summarySheetInr.getCell(`D${inrRow}`).value = 'Sum of SBR Eligible Amt (INR)';
    ['A', 'B', 'C', 'D'].forEach(col => {
      const cell = summarySheetInr.getCell(`${col}${inrRow}`);
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    });
    inrRow++;
    buKeys.forEach(bu => {
      summarySheetInr.getCell(`A${inrRow}`).value = bu;
      summarySheetInr.getCell(`B${inrRow}`).value = buMap[bu].dbk_inr;
      summarySheetInr.getCell(`C${inrRow}`).value = buMap[bu].rodtep_inr;
      summarySheetInr.getCell(`D${inrRow}`).value = buMap[bu].sbr_inr;
      ['B', 'C', 'D'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00');
      inrRow++;
    });
    summarySheetInr.getCell(`A${inrRow}`).value = 'Grand Total';
    if (buKeys.length > 0) {
      ['B', 'C', 'D'].forEach(c => {
        summarySheetInr.getCell(`${c}${inrRow}`).value = { formula: `SUM(${c}${it3Start + 1}:${c}${inrRow - 1})` };
      });
    } else {
      ['B', 'C', 'D'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).value = 0);
    }
    ['A', 'B', 'C', 'D'].forEach(c => {
      summarySheetInr.getCell(`${c}${inrRow}`).font = { bold: true };
      if (c !== 'A') summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00';
    });
    applyBordersInr(1, 4, it3Start, inrRow);
    inrRow += 3;

    // Table 4 (INR) — Total Trade Benefits
    summarySheetInr.getCell(`A${inrRow}`).value = 'Total Trade Benefits';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true, size: 13 };
    summarySheetInr.getCell(`A${inrRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    inrRow++;
    const it4Start = inrRow;
    const it4Headers = ['BU NAME', 'FTA', 'Customs Notification', 'SEZ Benefits', 'Sum of RODTEP', 'Sum of DBK', 'Sum of DBK SBR', 'Sum of Benefits Grand total'];
    it4Headers.forEach((h, i) => {
      const col = String.fromCharCode(65 + i);
      const cell = summarySheetInr.getCell(`${col}${inrRow}`);
      cell.value = h;
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
    });
    inrRow++;
    buKeys.forEach(bu => {
      const r = buMap[bu];
      ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach((c, i) => {
        const cell = summarySheetInr.getCell(`${c}${inrRow}`);
        if (i === 0) {
          cell.value = bu;
        } else if (i === 1) {
          cell.value = r.fta_forgone || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 2) {
          cell.value = r.customs_notif_forgone || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 3) {
          cell.value = r.sez_forgone || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 4) {
          cell.value = r.rodtep_inr || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 5) {
          cell.value = r.dbk_inr || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 6) {
          cell.value = r.sbr_inr || 0;
          cell.numFmt = '#,##0.00';
        } else if (i === 7) {
          cell.value = { formula: `B${inrRow}+C${inrRow}+D${inrRow}+E${inrRow}+F${inrRow}+G${inrRow}` };
          cell.numFmt = '#,##0.00';
        }
      });
      inrRow++;
    });
    summarySheetInr.getCell(`A${inrRow}`).value = 'Grand Total';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach(c => {
        summarySheetInr.getCell(`${c}${inrRow}`).value = { formula: `SUM(${c}${it4Start + 1}:${c}${inrRow - 1})` };
        summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00';
        summarySheetInr.getCell(`${c}${inrRow}`).font = { bold: true };
      });
    } else {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H'].forEach(c => {
        summarySheetInr.getCell(`${c}${inrRow}`).value = 0;
        summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00';
        summarySheetInr.getCell(`${c}${inrRow}`).font = { bold: true };
      });
    }
    applyBordersInr(1, 8, it4Start, inrRow);
    inrRow += 3;

    // Table 5 (INR) — Export Reports: RoDTEP/DBK/SBR Eligible vs Received vs
    // Pending, plus a Received/Eligible % column per incentive (guarded against
    // /0, unlike the reference file's bare division which throws #DIV/0!).
    summarySheetInr.getCell(`A${inrRow}`).value = 'Export Reports';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true, size: 13 };
    summarySheetInr.getCell(`A${inrRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
    inrRow++;
    const it5Start = inrRow;
    const it5Headers = [
      'Business Unit',
      'Sum of RoDTEP Amt. (INR)', 'Sum of RoDTEP Received Amt INR', 'Sum of RoDTEP Pending Amt INR',
      'Sum of DBK Amt. (INR)', 'Sum of DBK Received Amt INR', 'Sum of DBK Pending Amt INR',
      'Sum of SBR Eligible Amt (INR)', 'Sum of SBR Received Amt INR', 'Sum of SBR Pending Amt INR',
      'Rodtep in %', 'DBK in %', 'SBR in %',
    ];
    it5Headers.forEach((h, i) => {
      const col = String.fromCharCode(65 + i);
      const cell = summarySheetInr.getCell(`${col}${inrRow}`);
      cell.value = h;
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF8EAADB' } };
    });
    inrRow++;
    buKeys.forEach(bu => {
      const r = buMap[bu];
      summarySheetInr.getCell(`A${inrRow}`).value = bu;
      summarySheetInr.getCell(`B${inrRow}`).value = r.rodtep_inr || 0;
      summarySheetInr.getCell(`C${inrRow}`).value = r.rodtep_received_inr || 0;
      summarySheetInr.getCell(`D${inrRow}`).value = r.rodtep_pending_inr || 0;
      summarySheetInr.getCell(`E${inrRow}`).value = r.dbk_inr || 0;
      summarySheetInr.getCell(`F${inrRow}`).value = r.dbk_received_inr || 0;
      summarySheetInr.getCell(`G${inrRow}`).value = r.dbk_pending_inr || 0;
      summarySheetInr.getCell(`H${inrRow}`).value = r.sbr_inr || 0;
      summarySheetInr.getCell(`I${inrRow}`).value = r.sbr_received_inr || 0;
      summarySheetInr.getCell(`J${inrRow}`).value = r.sbr_pending_inr || 0;
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00');
      summarySheetInr.getCell(`K${inrRow}`).value = { formula: `IF(B${inrRow}<>0, C${inrRow}/B${inrRow}, 0)` };
      summarySheetInr.getCell(`L${inrRow}`).value = { formula: `IF(E${inrRow}<>0, F${inrRow}/E${inrRow}, 0)` };
      summarySheetInr.getCell(`M${inrRow}`).value = { formula: `IF(H${inrRow}<>0, I${inrRow}/H${inrRow}, 0)` };
      ['K', 'L', 'M'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '0.00%');
      inrRow++;
    });
    summarySheetInr.getCell(`A${inrRow}`).value = 'Grand Total';
    summarySheetInr.getCell(`A${inrRow}`).font = { bold: true };
    if (buKeys.length > 0) {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => {
        summarySheetInr.getCell(`${c}${inrRow}`).value = { formula: `SUM(${c}${it5Start + 1}:${c}${inrRow - 1})` };
      });
    } else {
      ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].forEach(c => summarySheetInr.getCell(`${c}${inrRow}`).value = 0);
    }
    summarySheetInr.getCell(`K${inrRow}`).value = { formula: `IF(B${inrRow}<>0, C${inrRow}/B${inrRow}, 0)` };
    summarySheetInr.getCell(`L${inrRow}`).value = { formula: `IF(E${inrRow}<>0, F${inrRow}/E${inrRow}, 0)` };
    summarySheetInr.getCell(`M${inrRow}`).value = { formula: `IF(H${inrRow}<>0, I${inrRow}/H${inrRow}, 0)` };
    ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'].forEach(c => {
      summarySheetInr.getCell(`${c}${inrRow}`).font = { bold: true };
      if (['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].includes(c)) summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '#,##0.00';
      if (['K', 'L', 'M'].includes(c)) summarySheetInr.getCell(`${c}${inrRow}`).numFmt = '0.00%';
    });
    applyBordersInr(1, 13, it5Start, inrRow);

    // Import Sheet — export only the columns the user has selected on the UI.
    const importSheet = workbook.addWorksheet('Import Data');
    const filteredImportColumns = importVisibility.filteredColumns;
    importSheet.columns = filteredImportColumns.map(col => ({ header: col.header, key: col.dataIndex, width: 20 }));
    applyExcelHeaderStyle(importSheet);
    // Thin border box on every header cell so the columns are easy to tell apart.
    const importHeaderRow = importSheet.getRow(1);
    for (let c = 1; c <= filteredImportColumns.length; c++) {
      importHeaderRow.getCell(c).border = {
        top: { style: 'thin' }, left: { style: 'thin' },
        bottom: { style: 'thin' }, right: { style: 'thin' },
      };
    }
    // Two-decimal number format for the numeric duty columns, resolved by
    // dataIndex so it follows the column to its new position after filtering.
    const importNumFmtKeys = [
      'be_assessable_amt_fcc', 'be_bcd_amt_fcc', 'be_sws_amt_fcc', 'total_duty_paid_fcc',
      'total_bcd_sws_inr', 'total_applicable_duty_inr', 'bcd_duty_forgone_fcc',
    ];
    const importNumFmtCols = importNumFmtKeys
      .map(k => filteredImportColumns.findIndex(col => col.dataIndex === k) + 1)
      .filter(pos => pos > 0);
    normalizedImportData.forEach(obj => {
      const newRow = importSheet.addRow({
        ...obj,
        be_date: getDateOnly(obj.be_date),
        ooc_date: getDateOnly(obj.ooc_date),
        assessment_date: getDateOnly(obj.assessment_date),
        inward_date: getDateOnly(obj.inward_date),
      });
      importNumFmtCols.forEach(colIdx => {
        newRow.getCell(colIdx).numFmt = '#,##0.00';
      });
    });

    // Export Sheet — export only the columns the user has selected on the UI.
    const exportSheet = workbook.addWorksheet('Export Data');
    const filteredExportColumns = exportVisibility.filteredColumns;
    exportSheet.columns = filteredExportColumns.map(col => ({ header: col.header, key: col.dataIndex, width: 20 }));
    applyExcelHeaderStyle(exportSheet);
    exportData.forEach(obj => {
      exportSheet.addRow({ ...obj, shb_dt: getDateOnly(obj.shb_dt), egm_date: getDateOnly(obj.egm_date) });
    });

    // Two-level grouping heading above the FCC/INR trios:
    //   Row 1 — IN FCC (all FCC trios) / IN INR (all INR trios)
    //   Row 2 — Eligible / Received / Pending (FCC) + Received / Pending (INR)
    // Ranges are resolved by dataIndex so they track the columns after filtering;
    // a group is drawn only over its members that are still visible.
    exportSheet.spliceRows(1, 0, [], []);
    const topGroupRow = exportSheet.getRow(1);
    const subGroupRow = exportSheet.getRow(2);
    const thinB = { style: 'thin' };
    const resolveGroups = defs => defs
      .map(g => {
        const positions = g.keys
          .map(k => filteredExportColumns.findIndex(col => col.dataIndex === k) + 1)
          .filter(pos => pos > 0);
        return positions.length
          ? { title: g.title, start: Math.min(...positions), end: Math.max(...positions) }
          : null;
      })
      .filter(Boolean);
    const fccTrios = {
      eligible: ['dbk_eligible_amt_fcc', 'rodtep_eligible_amt_fcc', 'sbr_eligible_amt_fcc'],
      received: ['dbk_received_amt_fcc', 'rodtep_received_amt_fcc', 'sbr_received_amt_fcc'],
      pending: ['dbk_pending_amt_fcc', 'rodtep_pending_amt_fcc', 'sbr_pending_amt_fcc'],
    };
    const inrTrios = {
      received: ['dbk_received_amt_inr', 'rodtep_received_amt_inr', 'sbr_received_amt_inr'],
      pending: ['dbk_pending_amt_inr', 'rodtep_pending_amt_inr', 'sbr_pending_amt_inr'],
    };
    const topGroups = resolveGroups([
      { title: 'IN FCC', keys: [...fccTrios.eligible, ...fccTrios.received, ...fccTrios.pending] },
      { title: 'IN INR', keys: [...inrTrios.received, ...inrTrios.pending] },
    ]);
    const subGroups = resolveGroups([
      { title: 'Eligible', keys: fccTrios.eligible },
      { title: 'Received', keys: fccTrios.received },
      { title: 'Pending', keys: fccTrios.pending },
      { title: 'Received', keys: inrTrios.received },
      { title: 'Pending', keys: inrTrios.pending },
    ]);
    const drawGroups = (rowNumber, row, groups) => {
      groups.forEach(g => {
        if (g.end > g.start) exportSheet.mergeCells(rowNumber, g.start, rowNumber, g.end);
        const cell = row.getCell(g.start);
        cell.value = g.title;
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC000' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        for (let c = g.start; c <= g.end; c++) {
          row.getCell(c).border = { top: thinB, bottom: thinB, left: thinB, right: thinB };
        }
      });
    };
    drawGroups(1, topGroupRow, topGroups);
    drawGroups(2, subGroupRow, subGroups);

    // Simple thin border on the field header band (now row 3) so the columns are
    // easy to tell apart (same style as the other headers).
    const fieldHeaderRow = exportSheet.getRow(3);
    for (let c = 1; c <= filteredExportColumns.length; c++) {
      fieldHeaderRow.getCell(c).border = { top: thinB, left: thinB, bottom: thinB, right: thinB };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Lucrative's CIP DSS - Import Duty Report as on ${getTodaysDate()} of ${selectedIEC}.xlsx`);
  };

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <Fragment>
      <style>{tableStyles}</style>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  Import Duty Reports &amp; Effective Duty Rate net of Incentive — {formattedDate} — {selectedIECName}
                </h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                <ColumnSelector
                  allColumns={activeTab === 'import' ? importColumns : exportColumns}
                  visibleKeys={activeTab === 'import' ? importVisibility.visibleKeys : exportVisibility.visibleKeys}
                  setVisibleKeys={activeTab === 'import' ? importVisibility.setVisibleKeys : exportVisibility.setVisibleKeys}
                  onReset={activeTab === 'import' ? importVisibility.resetToDefault : exportVisibility.resetToDefault}
                />
                <button className="btn btn-primary cip-btn-submit" onClick={exportToExcel}>
                  Export to Excel
                </button>
              </div>
            </Card.Header>

            <Card.Body className="d-flex justify-content-start align-items-center gap-2 ps-4 flex-wrap">
              {(userRole === 'superadmin' || userRole === 'group_head') && (
                <Select
                  showSearch
                  placeholder="Select IEC"
                  onChange={handleIECSelection}
                  allowClear
                  options={IECOptions}
                  style={{ width: '300px' }}
                />
              )}
              <ReportDateFilter dates={dates} onChange={handleDateChange} />
              <Select
                mode="multiple"
                allowClear
                showSearch
                placeholder="Select Branch"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={handleBranchCodeSelection}
                options={branchCodeNames.map(item => ({
                  value: item.branch_code,
                  label: `${item.branch_code} / ${item.plant_name} (${item.business_unit})`,
                }))}
                style={{ width: '300px' }}
              />
              <Input
                placeholder="Enter Bill No"
                allowClear
                value={billNo}
                onChange={e => setBillNo(e.target.value)}
                style={{ width: 200 }}
              />
              <Button type="primary" className="cip-btn-submit" onClick={handleSubmit}>
                Submit
              </Button>
            </Card.Body>

            <Card.Body className="px-3 report-page">
              <Tabs activeKey={activeTab} onChange={setActiveTab} type="card" size="middle">
                <TabPane tab="Import" key="import">
                  <Table
                    className="duty-saving-table"
                    bordered
                    size="small"
                    columns={importVisibility.filteredColumns}
                    dataSource={importData}
                    loading={isImportLoading}
                    rowKey={(record, index) => index}
                    scroll={{ x: 'max-content' }}

                    pagination={{ pageSize: 50, showSizeChanger: true, showTotal: total => `Total ${total} records` }}
                  />
                </TabPane>

                <TabPane tab="Export" key="export">
                  <Table
                    className="duty-saving-table"
                    bordered
                    size="small"
                    columns={exportVisibility.filteredColumns}
                    dataSource={exportData}
                    loading={isExportLoading}
                    rowKey={(record, index) => index}
                    scroll={{ x: 'max-content' }}

                    pagination={{ pageSize: 50, showSizeChanger: true, showTotal: total => `Total ${total} records` }}
                  />
                </TabPane>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default DutySavingReport;
